import './Page.css';
import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import Login from 'Components/Login/Login'
import Header from 'Components/Header/Header'
import Articlelist from 'Components/Articlelist/Articlelist'
import Article from 'Components/Article/Article'
import NewArticle from 'Components/NewArticle/NewArticle'

const Page = observer(
  class Page extends Component {
    state = {errmess:'', headerrmess:'', loggedin:false, username:'', userid:0,articleId:-1}
		websocketfails = 0;
		keepon = true;
		dummycallcount = 0;
		dummycalrunning = false;
		lastdummycaltime = 0;
		
		haveloggedin = (data) => {
			this.props.flow.cccmylog = this.mylog;
			if(data.userid == 0) {
				this.setState({errmess:'Error: could not log in, wrong password?', loggedin: false});
				this.mylog('login failed');
			}
			else {
				this.setState({errmess:'',loggedin: true,username:data.username,userid:data.userid});
				this.mylog('login success as ' + data.username);
				setTimeout(this.keepconnection,2300);
				setTimeout(this.chkDummyDuration,2300);
			}
		}

		logout = () => {
			document.location.reload();
			// this.setState({errmess:'', loggedin:false, username:'', userid:0,articleId:-1});
		}
		
		loadArticleList = () => {
			this.mylog('Page -> loadArticleList ');
			this.setState({articleId: -1});
			// this.setState({username:'baba'});
		}
		
		loadArticle = (id) => {
			this.mylog('Page -> loadArticle ' + id);
			this.setState({articleId: id});
			// this.setState({username:'baba'});
		}
		
		loadNewArticle = () => {
			this.mylog('Page -> loadNewArticle ');
			this.setState({articleId: 0});
			// this.setState({username:'baba'});
		}
		
		detectlogout = (res) => {
			this.mylog('***********LOGGET OUT***********************');
			this.mylog(res);
			alert(res);
			// document.location.reload();
		}
		
		
		mylog = (...messes) => {
			for(let mess of messes) {
				console.log(mess);
				this.logremote(this.myToString(mess));
				// if(document.getElementById("debugdiv")) 
					// document.getElementById("debugdiv").innerHTML += '<br>' + this.myToString(mess);
			}
		}
		
		myToString(o) {
			if(typeof(o) =='string')
					return o;
			if(typeof(o) == 'object') {
				try { 
					return JSON.stringify(o) 
				} catch(e) { 
					return e.message
				}
			}
		}
				
		setHeaderMess = (mess,terminal) => {
			if(terminal) 
				this.keepon = false;
			this.setState({headerrmess:mess});
		}
				
		logremote(mess) {
			var xhttp = new XMLHttpRequest();
			let params = 'userid='+this.state.userid+'&mess='+encodeURIComponent(mess);
			xhttp.onreadystatechange = function() {
				if (this.readyState == 4 && this.status == 200) {
				 // document.getElementById("debugdiv").innerHTML = this.responseText;
				}
			};
			xhttp.open("GET", "/log_dthd65z56zdd65htr/logme.php?"+params, true);
			xhttp.send();
		}		
		
		chkWebSocket = () => {
			if(!this.state.loggedin) return false;
			else if(!this.keepon) return false;
			else if(!this.props.flow.socket) {
				this.detectlogout('Verbindung verloren, bitte laden Sie die Seite neu!');
			}
			else if(this.props.flow.socket.readyState != 1) {
				this.websocketfails ++;
				if(this.websocketfails % 10 == 0)
					this.mylog('websocketfails: '+ this.websocketfails );
			}
			else {
				this.websocketfails = 0;
			}
			setTimeout(this.chkWebSocket,1000);
		}
		
		
		
		chkDummyDuration = () => {
			if(!this.state.loggedin) return false;
			if(!this.dummycalrunning) return false;
			let cddel = new Date().getTime() - this.lastdummycaltime;
			if(cddel > 999 && cddel % 2000 == 0) 
				this.mylog('ms since last dummycal was fired: '+ cddel + ' - Nr: ' + this.dummycallcount );
			else
				setTimeout(this.chkDummyDuration,100);
		}
		
		keepconnection = () => {
			if(!this.state.loggedin) return false;
			if(!this.keepon) return false;
			this.dummycalrunning = true;
			this.lastdummycaltime = new Date().getTime();
			this.chkDummyDuration();
			this.props.flow.getClipsByFulltext('ergeghuurdgtr')
				.then(res=>{
						if(typeof(res) == 'object' && res.clip) {
							this.dummycallcount++;
							this.setState({headerrmess:""});
							this.mylog('getClipsByFulltext_dummycall success ' + this.dummycallcount);
							this.dummycalrunning = false;
						}
				})
				.catch(res => {
					this.setState({headerrmess:"Sie wurden ausgeloggt, bitte neu einloggen!"});
					this.keepon = false;
					// this.setHeaderMess({headerrmess:"Sie wurden ausgeloggt, bitte neu einloggen!"},true);
					this.mylog('getdistproject_dummycall_failed:');
					this.mylog(res.message);
				}
			);
			setTimeout(this.keepconnection,10000);
		}
		
		
		
    render() {
			let mainview = <Articlelist  cbartsearchclicked={this.loadArticleList}  cbarticleclicked={this.loadArticle} userid={this.state.userid}/>
			if(this.state.articleId == 0) mainview = <NewArticle userid={this.state.userid} cbarticlesaved={this.loadArticle} />
			if(this.state.articleId > 0) mainview = <Article setHeaderMess={this.setHeaderMess} cbartsearchclicked={this.loadArticleList} userid={this.state.userid} id= {this.state.articleId} />
			return  (
				<div className="container">
					<div className="content">
					{ 
						!this.state.loggedin ? (
						<Login errmess={this.state.errmess} logincb={this.haveloggedin} />
						 ) : (
						 <>
						<Header headerrmess={this.state.headerrmess} articleId={this.state.articleId} cblogoutclicked={this.logout}   cbnewartclicked={this.loadNewArticle}  cbartsearchclicked={this.loadArticleList} username={this.state.username}/>
						{mainview}
						<div id="debugdiv" />
						</>
						)
					}
					</div>
				</div>
			)
    }
  }
)


export default Flow.injectFlow(Page);